import { Button } from "@volca/ui/components/ui/button";
import { Card } from "@volca/ui/components/ui/card";
import {
  PageContainer,
  PageHeader,
} from "@volca/ui/components/ui/page-components";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { useBreadcrumbs } from "@/app-shell";
import { useReportRun } from "@/profitability/query";
import {
  PROFITABILITY_PATH,
  LEGACY_REPORTS_PATH,
} from "@/profitability/routes";
import { reportError } from "@/profitability/utils";
import { LoadedReport } from "./loaded-report";
export const RunDetail = ({
  businessId,
  runId,
}: {
  businessId: string;
  runId: string;
}) => {
  const query = useReportRun(businessId, runId);
  useBreadcrumbs([
    { label: "Job Costing", href: PROFITABILITY_PATH },
    ...(query.data?.report
      ? [
          {
            label: query.data.report.name,
            href: LEGACY_REPORTS_PATH,
          },
        ]
      : []),
    { label: query.data?.display.period ?? "Report" },
  ]);

  if (query.isPending)
    return (
      <PageContainer variant="workspace" aria-busy>
        {/* The header's shape: a title line and the line under it. */}
        <Stack className="w-full" align="start" gap={1}>
          {/* PageTitle's line: 36px at a line-height of 0.95. */}
          <Skeleton className="h-8.5 w-64" />
          <Skeleton className="h-5 w-96 max-w-full" />
        </Stack>
        <Card className="min-h-0 w-full flex-1 gap-0 py-0" />
      </PageContainer>
    );

  // Only when there is nothing to show: a report polls every two seconds while
  // it builds, and one failed poll must not replace it with an error page.
  if (query.error && !query.data)
    return (
      <PageContainer>
        <PageHeader
          title="This report could not be loaded"
          description={reportError(query.error)}
        />
        <Stack className="w-full" gap={0} align="start">
          <Button variant="secondary" onClick={() => void query.refetch()}>
            Try again
          </Button>
        </Stack>
      </PageContainer>
    );

  return (
    <LoadedReport
      key={`${businessId}:${query.data.id}`}
      businessId={businessId}
      run={query.data}
    />
  );
};
